
import { defineComponent, Ref, inject } from "vue";

export default defineComponent({
  name: "SaveConfirmation",
  setup() {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    return {
      closeModal,
      fadeTransition,
      bounceTransition
    };
  },
});
